import { oc } from '@orpc/contract';
import { listReportsInputSchema, listReportsOutputSchema } from '../schemas/reports.schemas.js';
export const listReportsContract = oc
    .route({
    method: 'GET',
    path: '/reports',
    tags: ['Reports'],
    summary: 'List saved reports with their scenario, vehicles, author and date',
})
    .input(listReportsInputSchema)
    .output(listReportsOutputSchema);
//# sourceMappingURL=list-reports.contract.js.map